import React, { useMemo } from "react";
import "./Template1.css";
import "./Template4.css";

const Template4 = ({ checklist }) => {
  console.log("checklist cwp", checklist);

  // Create a map using checklist_item_id as key for O(1) lookup
  const checklistMap = useMemo(() => {
    const map = {};
    checklist?.forEach((item) => {
      map[item.checklist_item_id] = item;
    });
    return map;
  }, [checklist]);

  // Define your checklist item IDs (these are from your data)
  const CHECKLIST_IDS = {
    // Left Column - Items 1-10
    EQUIPMENT_INSPECTED: "7e3adb1e-d3df-11ef-8bb7-9c2dcdaf01ba",
    SURROUNDING_AREA: "7e3c4b71-d3df-11ef-8bb7-9c2dcdaf01ba",
    EQUIPMENT_STATUS: "7e3c57b9-d3df-11ef-8bb7-9c2dcdaf01ba",
    EQUIPMENT_DRAINED: "7e3c58f3-d3df-11ef-8bb7-9c2dcdaf01ba",
    ELECTRICALLY_ISOLATED: "7e3c595b-d3df-11ef-8bb7-9c2dcdaf01ba",
    EQUIPMENT_FLUSHED: "7e3c75ee-d3df-11ef-8bb7-9c2dcdaf01ba",
    EQUIPMENT_STEAMED: "7e3c773b-d3df-11ef-8bb7-9c2dcdaf01ba",
    VENTILATION_LIGHTING: "7e3c77a0-d3df-11ef-8bb7-9c2dcdaf01ba",
    AREA_CORDONED: "7e3c8aa5-d3df-11ef-8bb7-9c2dcdaf01ba",
    GAS_TEST: "7e3c8bec-d3df-11ef-8bb7-9c2dcdaf01ba",

    // Right Column - Scaffolding/Working at Height - Items 1-7
    SCAFFOLDING_TAG: "7e3c8c96-d3df-11ef-8bb7-9c2dcdaf01ba",
    SCAFFOLDING_TAG_SIGNED: "7e3c8ce3-d3df-11ef-8bb7-9c2dcdaf01ba",
    FULL_BODY_HARNESS: "7e3c8d9e-d3df-11ef-8bb7-9c2dcdaf01ba",
    SCAFFOLDING_BARRICADED: "7e3c8df2-d3df-11ef-8bb7-9c2dcdaf01ba",
    SAFETY_HARNESS_CERTIFIED: "7e3c8e53-d3df-11ef-8bb7-9c2dcdaf01ba",
    LIFELINE_ANCHORING: "7e3c9fa6-d3df-11ef-8bb7-9c2dcdaf01ba",
    LIFELINE_FALL_ARRESTING: "7e3ca177-d3df-11ef-8bb7-9c2dcdaf01ba",
  };

  // Helper function to get checklist item by ID
  const getItem = (id) => checklistMap[id];

  // Helper function to render checkmark
  const renderCheckmark = (item, status) => {
    if (item && item.work_status === status) {
      return <span className="checkmarks">&#10003;</span>;
    }
    return "";
  };

  return (
    <>
      <div className="template-container">
        <div className="template-container-content">
          <div className="template-container-header">
            <div className="cold-work-table">
              <table className="cold-work-tables">
                <thead>
                  <tr>
                    <th className="permit-center-align permit-1">
                      क्रम सं <br /> Sr.no
                    </th>
                    <th className="permit-center-align permit-2">
                      मद <br />
                      Item
                    </th>
                    <th className="permit-center-align permit-3">
                      किया गया <br /> Done
                    </th>
                    <th className="permit-center-align permit-4">
                      अपेक्षित नहीं <br /> Not Reqd.
                    </th>
                    <th className="permit-center-align permit-1">
                      क्रम सं <br /> Sr.no
                    </th>
                    <th className="permit-center-align permit-2">
                      मद <br />
                      Item
                    </th>
                    <th className="permit-center-align permit-3">
                      किया गया <br /> Done
                    </th>
                    <th className="permit-center-align permit-4">
                      अपेक्षित नहीं <br /> Not Reqd.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="permit-center-align">1</td>
                    <td>
                      उपकरण/कार्य क्षेत्र की जाँच की गई
                      <br /> Equipment/work area inspected
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">10</td>
                    <td>
                      <span className="span-table">
                        गैस टेस्ट एच सी टोक्सिक इत्यादि / Gas test:HCs/Toxic etc{" "}
                      </span>{" "}
                      <br /> एच सी /HCS(% एलईएल/LEL)
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.GAS_TEST)?.hc_gas ||
                          "..............."}
                      </span>{" "}
                      <br />
                      टोक्सिक गैस/Toxic gases(% पीपीएम/ppm):{" "}
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.GAS_TEST)?.toxic_gases ||
                          "..............."}
                      </span>{" "}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.GAS_TEST), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.GAS_TEST), 0)}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">2</td>
                    <td>
                      आसपास के क्षेत्र की जाँच, सफाई करली गई है और <br /> उसे ढक
                      दिया गया है। <br /> Surrounding area checked cleaned and
                      covered
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SURROUNDING_AREA),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SURROUNDING_AREA),
                        0
                      )}
                    </td>
                    <td colSpan="2" className="permit-center-align">
                      मचान निर्माण । ऊंचाई पर कार्य <br />
                      Working at height/Scaffolding Erection
                    </td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">3</td>
                    <td>
                      उपकरण की स्थिति की जाँच की गई /Equipment status checked
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.EQUIPMENT_STATUS)
                          ?.equipment_status || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STATUS),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STATUS),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">1</td>
                    <td>
                      मचान टैग प्रदान किया गया। <br /> Scaffolding Tag Provided
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SCAFFOLDING_TAG),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SCAFFOLDING_TAG),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">4</td>
                    <td>
                      उपकरण को उचित रूप से निस्तारिक और <br /> आवसादित किया गया।{" "}
                      <br />
                      Equipment properly drained and <br /> depressurized
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_DRAINED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_DRAINED),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">2</td>
                    <td>
                      ठकेदार पर्यवेक्षक और रखरखाव पर्यवेक्षक द्वारा <br />
                      हस्ताक्षरित मचान टैग / Scaffolding Tag signed <br /> by
                      contractor, supervisor, and <br /> maintenance supervisor.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SCAFFOLDING_TAG_SIGNED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SCAFFOLDING_TAG_SIGNED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">5</td>
                    <td>
                      उपकरण विधुत्त रूप से पृथक और अनुमती पत्र <br /> कृमांक के
                      द्वारा टैग कर दिया गया है / Equipment <br /> Electrically
                      isolated and tagged vide permit <br /> no.:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.ELECTRICALLY_ISOLATED)
                          ?.permit_no || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.ELECTRICALLY_ISOLATED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.ELECTRICALLY_ISOLATED),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">3</td>
                    <td>
                      शॉक एब्जॉर्बर के साथ सुरक्षा बेल्ट का प्रयोग किया है।{" "}
                      <br /> /Full body harness with shock absorber <br /> used.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.FULL_BODY_HARNESS),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.FULL_BODY_HARNESS),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">6</td>
                    <td>
                      उपकरण को पानी से फ्लश किया गया <br /> Equipment water
                      flushed
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_FLUSHED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_FLUSHED),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">4</td>
                    <td>
                      मचान क्षेत्र की घेराबन्दी की गयी। <br /> Scaffolding area
                      barricaded
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SCAFFOLDING_BARRICADED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SCAFFOLDING_BARRICADED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">7</td>
                    <td>
                      उपकरण को उचित रूप से भाप द्वारा पर्ज किया <br /> किया गया
                      है/ Equipment properly <br /> steamed/purged
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STEAMED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STEAMED),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">5</td>
                    <td>
                      IS/EN द्वारा प्रमाणित सुरक्षा बेल्ट का प्रयोग किया गया।{" "}
                      <br /> IS/EN certified safety harness used.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SAFETY_HARNESS_CERTIFIED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SAFETY_HARNESS_CERTIFIED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">8</td>
                    <td>
                      उचित वातानुकूलन एवं प्रकाश प्रदान किया गया <br /> /Proper
                      ventilation and lighting provided
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.VENTILATION_LIGHTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.VENTILATION_LIGHTING),
                        0
                      )}
                    </td>
                    <td className="permit-center-align">6</td>
                    <td>
                      सुरक्षा बेल्ट और लाइफलाइन को बांधने के लिए मजबूत <br />
                      स्ट्रक्चर का उपयोग किया है यह सुनिश्चित किया गया <br />{" "}
                      Safety belt life line anchoring to the rigid <br />{" "}
                      structure to be ensured
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.LIFELINE_ANCHORING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.LIFELINE_ANCHORING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td className="permit-center-align">9</td>
                    <td>
                      क्षेत्र की घेराबंदी कर दी गई है एवं टैग दिए है। चेतावनी{" "}
                      <br />
                      बोर्ड टैग दे दिए है। <br /> Area cordoned off & caution
                      boards/Tags <br /> provided
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.AREA_CORDONED), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.AREA_CORDONED), 0)}
                    </td>
                    <td className="permit-center-align">7</td>
                    <td>
                      सुरक्षित रास्ता की अनुपस्थिति में ऊंचाई पर मुवमेंट के{" "}
                      <br />
                      लिए वर्टीकल हॉरिजॉन्टल लाइफलाइन का उपयोग <br /> सुनिश्चित
                      किया गया। <br /> In the absence of fixed means of access,{" "}
                      <br />
                      provisions of lifelines with fall arresting for <br />{" "}
                      both vertical and horizontal movement is <br /> to be
                      ensured.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.LIFELINE_FALL_ARRESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.LIFELINE_FALL_ARRESTING),
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Template4;